export const apiResConstants={
    X_SUN_CHAL:'ESHOP',
    CUSTOMER : '/profile',
    ADDR_ENDPOINT : '/suggest/address',
    LINE_CHECK : '/v1/linecheck',
    CONSTANTSKEYS: '/rest/cms/dsource_entries?datasource=one-ecommerce-constant-keys',
    X_SUN_SITEID:'7230009036',
    SERVICE_OPTIONS_BY_OFFER: 'v2/service-options?offerId=',
    // B2B Channel
    X_SUN_B2B_CHAL: 'SBO',
    GET_CART: 'carts/:cartId',
    THREE_SCALE_API_KEY: 'THREE_SCALE_API_KEY',
}
